module.exports = __webpack_public_path__ + "static/media/check_icon.3cda0323.svg";